import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "290px 1410px",
    backgroundColor: "#fff",
    minHeight: 132,
    maxHeight: 132,
    overflow: "hidden",
    borderBottom: "1px solid #797979",
    position: "fixed",
    zIndex: 2,
    boxShadow: "0px 2px 7px 0px rgba(0, 0, 0, 0.15)"
  },
  scrollableHeaders: {
    display: "grid",
    gridTemplateColumns: "90px 660px 660px",
    maxWidth: "calc(100vw - 510px)",
    overflowX: "auto",
    [theme.breakpoints.down(Breakpoints.MD_960)]: {
      maxWidth: "calc(100vw - 374px)"
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxWidth: "calc(100vw - 290px)"
    },
    borderRight: "1px solid"
  },
  emptyCell: {
    height: 88
  },
  headerColumns: {
    display: "grid",
    gridTemplateColumns: "127px 163px"
  },
  narrowBorderTop: {
    borderTop: "1px solid #797979"
  },
  headCell: {
    height: 44,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "#232323",
    fontSize: 12,
    fontWeight: 700
  }
}));
